import React, { useEffect, useState } from 'react';
import SearchRow from 'components/SearchRow/SearchRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { get } from 'lib/comms';
import Table from 'components/Table/Table';
import MicroLearningPage from './MicroLearningPage';
import moment from 'moment';
import { Navigate, useLocation } from 'react-router-dom';
import SubscriptionBanner from 'components/SubscriptionBanner/SubscriptionBanner';
import ToolTip from 'components/ToolTip/TooltTip';

const LEARNING_TOOLTIPS = [
    {
        target: '.searchrow-btn',
        title: 'Add New Micro Learning',
        content:
            'Micro learning is a great way to share learning modules with your users in a quick user friendly format. To create your micro learning select add new material.',
        placement: 'left',
    },
    {
        target: '.tabrow-tab.active',
        title: 'Adding information about your micro learning',
        content:
            'Complete the form below with information about this learning module, you can attach an image, title, description and allocate a estimated time to complete as a guide to users as well as award points for completing this learning module. When you are done select save to progress to the next step to create the questions.',
        placement: 'right',
    },
    {
        target: '.tabrow-tab.active',
        title: 'Creating your micro learning',
        content:
            'You can build your learning from here by selecting either a question or a statement. If you select a question you will have free text to create a question and a list of answers, simply select the correct answer or multiple answers. Statements are great to share information in-between the questions. Each question or statement will be displayed on its own screen in the app.',
        placement: 'right',
    },
    {
        target: '.text-button',
        title: 'Saving and Publishing your micro learning',
        content:
            'When you are done creating your micro learning select save and then return to the about section and select "Post Learning" this will make the learning available in the app for users to participate in. When users start to complete the micro learning you will see a third tab for "result" where you can view the average results for each question. You can archive your micro learning at anytime. This will mean it is no longer available in the app for users to participate in but you will still have access to the micro learning module and the results from the CMS',
        placement: 'left',
    },
];

// export default class MicroLearningsPage extends React.Component {
const MicroLearningsPage = (props) => {
    const location = useLocation();

    const navigationState = location?.state;
    const previousPage = navigationState?.from;
    const fromAnotherPage = navigationState?.from === 'onboarding' || navigationState?.from === 'campaigns';

    const [state, setState] = useState({
        data: [],
        search: '',
        activeTab: null,
        editing: fromAnotherPage ? { id: 'new' } : null,
        stepIndex: 0,
    });

    const columns = [
        {
            name: 'Micro-Learning Material',
            // selector: 'name',
            selector: (row) => row.name,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Date Posted',
            // selector: 'posted_date',
            selector: (row) => row.posted_date,
            sortable: true,
            format: (row) => (row.posted_date ? moment(row.posted_date).format('DD MMM YYYY') : ''),
        },
        { name: 'Completed by', selector: 'user_count', center: true, sortable: true },
        {
            name: 'Average Score',
            // selector: 'score',
            selector: (row) => row.score,
            center: true,
            sortable: true,
            format: (row) =>
                row.score ? `${((100 * row.score) / (row.user_count * (row.out_of || 1))).toFixed(0)}%` : '',
        },
        {
            name: 'Status',
            // selector: 'active',
            selector: (row) => row.active,
            sortable: true,
            center: true,
            format: (row) => (row.posted_date ? (row.active ? 'Active' : 'Archived') : 'Not posted'),
        },
        {
            name: '',
            // selector: 'id',
            selector: (row) => row.id,
            sortable: false,
            grow: 0,
            right: true,
            cell: () => <FontAwesomeIcon color="#999" icon={faChevronRight} />,
        },
    ];

    const updateItemCreated = () => {
        setState({ ...state, createdNew: true });
    };

    const doneEditing = () => {
        if (fromAnotherPage) {
            setState({ fromAnotherPage: true });
        } else {
            setState({ editing: null });
            reload();
        }
    };

    const reload = async () => {
        let resp = await get('cms/learnings', null, true);
        if (resp && resp.status === 401) setState({ ...state, logout: true });
        if (resp && resp.learnings) setState({ data: resp.learnings });
        else console.log(resp);
    };

    useEffect(() => {
        reload();
    }, [setState]);

    if (state.logout) return <Navigate to={{ pathname: '/logout', state: { from: props.location } }} />;
    if (state.fromAnotherPage) {
        return (
            <Navigate
                to={{
                    pathname: `/${previousPage}`,
                    state: { ...navigationState, from: 'learning', createdNew: state.createdNew },
                }}
            />
        );
    }
    let { data, search, editing, stepIndex } = state;
    if (search) {
        data = data.filter((item) => `${item.name} ${item.category}`.toLowerCase().indexOf(search.toLowerCase()) >= 0);
    }

    return (
        <>
            {state.editing ? (
                // <h1> MICRO LEARNING PAGE</h1>
                <MicroLearningPage
                    learning={editing}
                    onBack={doneEditing}
                    updateItemCreated={updateItemCreated}
                    activeTab={state.activeTab}
                    reload={reload}
                />
            ) : (
                <div className="maincontainer">
                    <SubscriptionBanner />
                    <h4>Micro-Learning</h4>
                    <SearchRow
                        value={search}
                        searchTitle="Search by name of Micro-Learning material"
                        onSearch={(search) => setState({ ...state, search })}
                        buttonTitle="ADD NEW MATERIAL"
                        onBtnClick={(item) => setState({ ...state, editing: { id: 'new' } })}
                    />
                    <Table
                        columns={columns}
                        data={data}
                        onRowClicked={(item) => setState({ ...state, editing: item, activeTab: null })}
                        tableID="microlearning"
                        defaultSortField={columns[1].selector}
                    />
                </div>
            )}
            <ToolTip
                style={{ width: 480 }}
                screenId={'learning'}
                stepIndex={state.stepIndex}
                callback={(tooltipData) => {
                    if (tooltipData.lifecycle === 'complete') {
                        const activeTab =
                            stepIndex === 3 || stepIndex === 1 || (stepIndex === 2 && tooltipData.action === 'next')
                                ? 'Questions'
                                : 'About';
                        setState({
                            ...state,
                            stepIndex: tooltipData.action === 'prev' ? tooltipData.index - 1 : tooltipData.index + 1,
                            activeTab,
                            editing:
                                ((stepIndex === 0 || stepIndex === 1 || stepIndex === 2) &&
                                    tooltipData.action === 'next') ||
                                ((stepIndex === 2 || stepIndex === 3) && tooltipData.action === 'prev')
                                    ? { id: 'new' }
                                    : null,
                        });
                    }
                }}
                steps={LEARNING_TOOLTIPS}
            />
        </>
    );
};

export default MicroLearningsPage;
